import {compose} from 'redux';
import withCitiesAndStreets from 'common/components/hoc-helpers/withCitiesAndStreets';
import TabSurveyAssets from './TabSurveyAssets-redux';

export default compose(
  withCitiesAndStreets
)(TabSurveyAssets);
